import { type ApolloCache, type Reference } from "@apollo/client";

// Adds a message to its chat's cached thread, once, in id order: the send's
// answer and a live update can both bring the same new message.
export const appendMessage = (
  cache: ApolloCache,
  conversationId: string,
  message: { __typename?: "Message"; id: string } | null | undefined,
) => {
  if (!message) return;
  const ref = cache.identify({ __typename: "Message", id: message.id });
  if (!ref) return;
  cache.modify({
    id: cache.identify({ __typename: "Conversation", id: conversationId }),
    fields: {
      messages: (
        existing: readonly Reference[],
        { readField, toReference },
      ) => {
        if (existing.some((item) => readField("id", item) === message.id)) {
          return existing;
        }
        const added = toReference(ref);
        if (!added) return existing;
        return [...existing, added].sort(
          (a, b) => Number(readField("id", a)) - Number(readField("id", b)),
        );
      },
    },
  });
};
